import { createContext, useContext } from 'react'
import { observable, action } from 'mobx'

class SnackbarStore {
    @observable openDuration: number = 5000
    @observable isOpen: boolean = false
    @action setOpenSnackbar = (isOpen: boolean) => (this.isOpen = isOpen)
}

const snackbarStoreContent = createContext(new SnackbarStore())
const useSnackbarStore = () => useContext(snackbarStoreContent)

export default useSnackbarStore
